import { useTranslation } from 'react-i18next';
import { hhmm } from '../lib/format';

interface Props {
  scheduled: string;
  /** Erwartete Zeit laut Datenquelle; null oder gleich der Planzeit = pünktlich. */
  estimated: string | null;
  /** Verspätung in Minuten – zeigt zusätzlich die Pille "+X Min". */
  delayMinutes?: number | null;
}

/**
 * Zeitangabe eines Fluges mit Verspätungskennzeichnung: weicht die erwartete
 * Zeit von der geplanten ab, wird die Planzeit durchgestrichen und die
 * erwartete Zeit daneben gestellt.
 */
export function FlightTime({ scheduled, estimated, delayMinutes }: Props) {
  const { t } = useTranslation();
  const revised = estimated && estimated !== scheduled ? estimated : null;
  const delayed = typeof delayMinutes === 'number' && delayMinutes > 0;

  return (
    <span className="flight-time" data-delayed={revised ? true : undefined}>
      <span className={revised ? 'struck' : undefined}>{hhmm(scheduled)}</span>
      {revised && <span className="revised">{hhmm(revised)}</span>}
      {delayed && <span className="pill pill-delay">{t('game.delay', { count: delayMinutes! })}</span>}
    </span>
  );
}
